import Catchphraser from "../components/Catchphraser"
import CatchphraserPresentation from "../components/CatchphraserPresentation"
const Presentation = ()=>{
    return(
    <CatchphraserPresentation/>)
}
export default Presentation